(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pv-dispatch-date"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pv-dispatch-date')) {
    customElements.define('pv-dispatch-date', class extends HTMLElement {
      connectedCallback() {
        this.updateDate = this.updateDate.bind(this);
        this.updateDate();
        if (!this.dataset.customDate) {
          this.timer = setInterval(this.updateDate, 60000);
          document.addEventListener('visibilitychange', this.updateDate);
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        document.removeEventListener('visibilitychange', this.updateDate);
      }

      updateDate() {
        const time = this.querySelector('time');
        if (!time) return;
        let iso = this.dataset.customDate;
        if (!iso) {
          const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: this.dataset.timeZone,
            year: 'numeric', month: '2-digit', day: '2-digit'
          }).formatToParts(new Date());
          const value = (type) => Number(parts.find((part) => part.type === type).value);
          iso = new Date(Date.UTC(value('year'), value('month') - 1, value('day') + 1)).toISOString().slice(0, 10);
        }
        const date = new Date(iso + 'T12:00:00Z');
        if (Number.isNaN(date.getTime())) return;
        time.dateTime = iso;
        time.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
          timeZone: 'UTC', month: 'long', day: 'numeric', year: 'numeric'
        }).format(date);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-option-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pv-option-rail')) {
    customElements.define('pv-option-rail', class extends HTMLElement {
      connectedCallback() {
        this.cards = this.querySelector('.pv-option__cards');
        this.previous = this.querySelector('[data-direction="prev"]');
        this.next = this.querySelector('[data-direction="next"]');
        this.drawer = this.closest('details');
        if (!this.cards || !this.previous || !this.next) return;
        this.revealSelected = () => {
          if (!this.drawer?.open) return;
          const selected = this.cards.querySelector('.pv-choice__input:checked')?.closest('.pv-choice');
          if (!selected) return;
          const rail = this.cards.getBoundingClientRect();
          const choice = selected.getBoundingClientRect();
          if (choice.right > rail.right + 1) this.cards.scrollLeft += choice.right - rail.right;
          if (choice.left < rail.left - 1) this.cards.scrollLeft += choice.left - rail.left;
        };
        this.updateArrows = () => {
          const maximum = Math.max(0, this.cards.scrollWidth - this.cards.clientWidth);
          const position = Math.max(0, this.cards.scrollLeft);
          this.previous.hidden = position <= 1;
          this.next.hidden = maximum <= 1 || position >= maximum - 1;
        };
        this.handleToggle = () => {
          this.revealSelected();
          this.updateArrows();
        };
        this.cards.addEventListener('scroll', this.updateArrows, { passive: true });
        this.drawer?.addEventListener('toggle', this.handleToggle);
        this.resizeObserver = new ResizeObserver(this.handleToggle);
        this.resizeObserver.observe(this.cards);
        requestAnimationFrame(this.handleToggle);
      }
      disconnectedCallback() {
        this.cards?.removeEventListener('scroll', this.updateArrows);
        this.drawer?.removeEventListener('toggle', this.handleToggle);
        this.resizeObserver?.disconnect();
      }
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.pv-option__rail-button');
    if (!button) return;
    const cards = button.closest('.pv-option__rail')?.querySelector('.pv-option__cards');
    const card = cards?.querySelector('.pv-choice');
    if (!cards || !card) return;
    const gap = parseFloat(getComputedStyle(cards).columnGap) || 0;
    const distance = card.getBoundingClientRect().width + gap;
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    cards.scrollBy({ left: button.dataset.direction === 'next' ? distance : -distance, behavior });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-product-layout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pv-product-subtotal')) {
    customElements.define('pv-product-subtotal', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.unitPrice = Number(this.dataset.unitPrice);
        this.updateTotal = this.updateTotal.bind(this);
        this.productInfo?.addEventListener('input', this.updateTotal);
        this.productInfo?.addEventListener('change', this.updateTotal);
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) !== this.productInfo?.dataset.section) return;
          this.unitPrice = data.variant.price;
          this.updateTotal();
        });
        this.updateTotal();
      }
      disconnectedCallback() {
        this.productInfo?.removeEventListener('input', this.updateTotal);
        this.productInfo?.removeEventListener('change', this.updateTotal);
        this.unsubscribe?.();
      }
      updateTotal() {
        const quantity = Number(this.productInfo?.querySelector('.quantity__input')?.value || 1);
        const total = this.querySelector('[data-subtotal-amount]');
        if (!total || !Number.isFinite(this.unitPrice) || !Number.isFinite(quantity)) return;
        total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code'
        }).format(this.unitPrice * quantity / 100);
        const reference = this.querySelector('[data-reference-usd]');
        if (reference) reference.dataset.referenceUsd = String(this.unitPrice * quantity);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
